module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('a', {
    attrs: {
      "id": "start"
    }
  }, [_vm._v("It is a lovely thing to live with courage, and die leaving an everlasting fame.")])]), _c('a', {
    attrs: {
      "id": "start"
    }
  }, [_c('p', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("ALEXANDER")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("You know that the more magnificent the prospect, the lesser the certainty, and also the greater the passion.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("SIGMUND FREUD")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1544c04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4-epigraph.vue
// module id = 72
// module chunks = 0